class ScrollTabsComponent extends HTMLElement {
    constructor() {
        super();
        this.tabs = [];
        this.panels = [];
    }

    connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-custom-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-custom-tab-panel]'));
        this.syncTabMetaFromPanels()
    }

    syncTabMetaFromPanels() {
        this.tabs.forEach((tab, index) => {
            const panel = this.panels[index];
            if (!(panel instanceof HTMLElement)) return;

            const label = (panel.dataset.customTabLabel || '').trim();
            const link_id = (panel.dataset.scrollTabId || '').trim();
            if (label) {
                const labelNode = tab.querySelector('.custom-tabs__tab-label');
                if (labelNode) {
                    labelNode.textContent = label;
                } else {
                    tab.textContent = label;
                }
            }

            if (link_id) {
                tab.href = link_id
            }
        });
    }
}

if (!customElements.get('scroll-tabs-component')) {
  customElements.define('scroll-tabs-component', ScrollTabsComponent);
}